import { render, staticRenderFns } from "./ScanBox.vue?vue&type=template&id=b5bc9eb8&scoped=true&"
import script from "./ScanBox.vue?vue&type=script&lang=js&"
export * from "./ScanBox.vue?vue&type=script&lang=js&"
import style0 from "./ScanBox.vue?vue&type=style&index=0&id=b5bc9eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bc9eb8",
  null
  
)

export default component.exports